import { QuizConfig } from '../../types/quiz';

const stressIndexQuiz: QuizConfig = {
  id: 'stress-index',
  title: '스트레스 지수 테스트',
  shortTitle: '스트레스 지수',
  description: '12가지 질문으로 나의 스트레스 수준을 확인해보세요',
  icon: '😰',
  gradient: ['#FFECB3', '#FF8A65'],
  headerColor: '#FFE0B2',
  questions: [
    { id: 1, description: '최근 잠들기 어렵거나 자주 깹니까?', yesScore: -3, noScore: 3 },
    { id: 2, description: '식욕이 크게 줄었거나 폭식하는 경향이 있습니까?', yesScore: -3, noScore: 3 },
    { id: 3, description: '사소한 일에도 짜증이 잘 납니까?', yesScore: -3, noScore: 3 },
    { id: 4, description: '업무나 학업에 집중하기 어렵습니까?', yesScore: -3, noScore: 3 },
    { id: 5, description: '두통, 어깨 결림 등 원인 모를 통증이 있습니까?', yesScore: -3, noScore: 3 },
    { id: 6, description: '항상 피곤하고 에너지가 부족하다고 느낍니까?', yesScore: -4, noScore: 3 },
    { id: 7, description: '취미나 즐거운 활동에 흥미를 잃었습니까?', yesScore: -3, noScore: 4 },
    { id: 8, description: '이유 없이 불안하거나 걱정이 많습니까?', yesScore: -3, noScore: 3 },
    { id: 9, description: '나만의 스트레스 해소법이 있습니까?', yesScore: 4, noScore: -2 },
    { id: 10, description: '주변 사람들과 고민을 나누는 편입니까?', yesScore: 3, noScore: -3 },
    { id: 11, description: '규칙적으로 운동이나 산책을 합니까?', yesScore: 4, noScore: -2 },
    { id: 12, description: '하루에 자신만의 휴식 시간을 가집니까?', yesScore: 3, noScore: -3 },
  ],
  explanations: [
    { good: '수면의 질이 좋다면 스트레스 회복력이 높은 상태입니다!', bad: '수면 장애는 스트레스의 대표적인 신호입니다.' },
    { good: '안정된 식습관은 정서적 안정의 반영입니다!', bad: '스트레스는 식욕 조절 호르몬에 직접 영향을 줍니다.' },
    { good: '감정 조절이 잘 되고 있어요!', bad: '쉽게 짜증나는 것은 스트레스 과부하의 신호일 수 있습니다.' },
    { good: '집중력이 유지되고 있다면 스트레스 수준이 관리되고 있어요!', bad: '집중력 저하는 만성 스트레스의 흔한 증상입니다.' },
    { good: '신체 증상이 없다면 자율신경계가 안정적입니다!', bad: '원인 모를 통증은 스트레스로 인한 근육 긴장일 수 있습니다.' },
    { good: '에너지가 충분하다면 건강한 상태입니다!', bad: '만성 피로는 스트레스 호르몬(코르티솔) 과다 분비의 결과일 수 있습니다.' },
    { good: '취미 활동은 스트레스 해소에 매우 효과적입니다!', bad: '무쾌감증은 번아웃의 초기 신호일 수 있습니다.' },
    { good: '불안 없이 안정적인 상태를 유지하고 계시네요!', bad: '만성 불안은 스트레스 관련 장애로 발전할 수 있습니다.' },
    { good: '자신만의 해소법이 있다면 스트레스에 강한 사람입니다!', bad: '스트레스 해소법이 없으면 부정적 감정이 누적됩니다.' },
    { good: '사회적 지지는 스트레스 완충 효과가 매우 큽니다!', bad: '고민을 혼자 안으면 스트레스가 배가 됩니다.' },
    { good: '규칙적 운동은 천연 항불안제 역할을 합니다!', bad: '운동 부족은 스트레스 호르몬 조절 능력을 떨어뜨립니다.' },
    { good: '자기만의 시간은 정신 건강의 필수 요소입니다!', bad: '휴식 없는 생활은 번아웃으로 이어질 수 있습니다.' },
  ],
  healthTips: [
    { question: '수면', tip: '취침 1시간 전 스마트폰을 내려놓고, 따뜻한 물로 샤워하세요.', icon: '🛏️' },
    { question: '식욕', tip: '규칙적인 식사 시간을 지키고, 스트레스 먹방 대신 건강한 간식을 준비하세요.', icon: '🍽️' },
    { question: '감정조절', tip: '화가 날 때 10초 심호흡을 해보세요. 감정 일기도 도움이 됩니다.', icon: '🧘' },
    { question: '집중력', tip: '뽀모도로 기법(25분 집중 + 5분 휴식)을 활용해보세요.', icon: '⏱️' },
    { question: '신체 통증', tip: '스트레칭과 마사지로 근육 긴장을 풀어주세요. 증상이 지속되면 병원 방문을 권합니다.', icon: '💆' },
    { question: '피로', tip: '하루 7-8시간 수면을 확보하고, 카페인은 오후 2시 이전까지만 섭취하세요.', icon: '☕' },
    { question: '취미/흥미', tip: '좋아했던 활동을 다시 시작해보세요. 새로운 취미를 찾는 것도 좋습니다.', icon: '🎨' },
    { question: '불안', tip: '걱정 노트를 만들어 불안한 생각을 적어보세요. 객관화하면 불안이 줄어듭니다.', icon: '📓' },
    { question: '스트레스 해소', tip: '명상, 운동, 음악 감상, 자연 산책 등 나만의 해소법을 만들어보세요.', icon: '🌿' },
    { question: '대인관계', tip: '믿을 수 있는 사람에게 고민을 나눠보세요. 전문 상담도 좋은 방법입니다.', icon: '💬' },
    { question: '운동', tip: '매일 30분 걷기나 가벼운 조깅으로 엔도르핀을 분비시키세요.', icon: '🚶' },
    { question: '휴식', tip: '하루 30분은 오롯이 나를 위한 시간으로 정해두세요.', icon: '☀️' },
  ],
  categories: [
    { name: '신체 증상', color: '#f44336', indices: [0, 4, 5] },
    { name: '정서 상태', color: '#FF9800', indices: [2, 7] },
    { name: '생활 기능', color: '#2196F3', indices: [1, 3, 6] },
    { name: '대처 능력', color: '#4CAF50', indices: [8, 9, 10, 11] },
  ],
  resultTiers: [
    { maxScore: -12, title: '멘탈 폭격기', emoji: '💣' },
    { maxScore: -4, title: '스트레스 맛집', emoji: '🫠' },
    { maxScore: 6, title: '그럭저럭 버티는 중', emoji: '😮‍💨' },
    { maxScore: 16, title: '멘탈 강철', emoji: '🛡️' },
    { maxScore: Infinity, title: '부처님 마인드', emoji: '🧘' },
  ],
  baseValue: 50,
  resultUnit: '점',
  resultPrefix: '스트레스 지수 ',
  resultSuffix: '',
  percentile: { mean: 5, sd: 12 },
  seo: {
    title: '스트레스 지수 테스트 - 나의 스트레스 수준은?',
    description: '12가지 질문으로 스트레스 수준을 자가진단해보세요. 신체 증상, 정서 상태, 대처 능력을 종합 평가합니다.',
  },
};

export default stressIndexQuiz;
